import { Typography, Box } from '@mui/material';

const DocsOverview = () => {
  return (
    <Box>
      <Typography variant="h1" gutterBottom>
        Overview
      </Typography>
      <Typography variant="body1" paragraph>
        ClassChronicle is a comprehensive and advanced scheduling platform
        designed to streamline the timetable management for educational
        institutions. It provides an intuitive interface for administrators to
        upload Excel data, ensuring fast adoption, flexibility and efficiency in
        timetable management.
      </Typography>

      <Typography variant="h2" gutterBottom>
        Key Features
      </Typography>
      <ul>
        <li>
          <Typography variant="body1">
            <strong>Automated Scheduling:</strong> Generate optimized timetables
            with a single click.
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            <strong>Flexible Configuration:</strong> Customize timetable
            parameters to fit institutional needs.
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            <strong>Department & Course Management:</strong> Organize subjects,
            teachers, students, and classrooms into departments.
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            <strong>Classroom Types & Room Allocation:</strong> Define class
            room types to ensure proper classroom and labs allocation.
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            <strong>Excel Upload & Manual Entry:</strong> Choose between bulk
            data import via Excel or manual input for fine-grained control.
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            <strong>Visualization & Export:</strong> View and export timetables
            in various formats.
          </Typography>
        </li>
      </ul>

      <Typography variant="h2" gutterBottom>
        User Roles
      </Typography>
      <ul>
        <li>
          <Typography variant="body1">
            <strong>Administrators:</strong> Manage configurations and oversee
            timetable generation.
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            <strong>Teachers:</strong> View assigned schedules and classrooms.
            <Typography variant="body2">
              (Upcoming: Ability to request schedule changes, mark availability,
              and sync with calendar apps.)
            </Typography>
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            <strong>Students:</strong> Access their specific class schedules.
            <Typography variant="body2">
              (Upcoming: Personalized notifications, timetable reminders, and
              integration with student portals.)
            </Typography>
          </Typography>
        </li>
      </ul>

      <Typography variant="body1" paragraph>
        This documentation will guide you through the registeration process,
        data entry, configuration, timetable creation, and viewing/exporting
        options to ensure seamless usage of the platform.
      </Typography>
    </Box>
  );
};

export default DocsOverview;
